import './index.scss';
import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import ourPropTypes from '../../../js/ourPropTypes';
import { clearNotification } from '../../../js/actions/notificationActionCreators';
import FormErrorNotification from '../FormErrorNotification';

const AppErrorNotification = React.createClass({
    propTypes: {
        notification: ourPropTypes.notification,
        clearNotification: PropTypes.func.isRequired
    },
    onDismiss: function() {
        this.props.clearNotification(this.props.notification);
    },
    render: function() {
        if (!this.props.notification) { return null; };

        return <div className="app-error-holder">
            <FormErrorNotification error={this.props.notification.message} onDismiss={this.onDismiss} />
        </div>;
    }
});

const mapStateToProps = (state) => ({
    notification: state.app.notifications.page
});

const mapDispatchToProps = (dispatch) => ({
    clearNotification: (notification) => {
        dispatch(clearNotification(notification));
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(AppErrorNotification);


// WEBPACK FOOTER //
// ./src/components/common/AppErrorNotification/index.jsx